import { Navigate, useLocation, useParams } from 'react-router-dom';

/**
 * Analytics used to be nested under the monitor (`/monitor/:siteId/analytics/*`).
 * Forwards those bookmarks and shared report links to `/analytics/:siteId/*`,
 * keeping the report path and query string.
 */
export function LegacyAnalyticsRedirect() {
  const { siteId = '', '*': rest = '' } = useParams();
  const { search } = useLocation();
  const tail = rest ? `/${rest}` : '';
  return <Navigate to={`/analytics/${encodeURIComponent(siteId)}${tail}${search}`} replace />;
}
